import { createApp } from "vue";
import FeaturedBlock from "../apps/FeaturedBlock.vue";


export default () => {
const app = createApp({});

Array.prototype.unique = function () {
    return this.filter((value, index, self) => self.indexOf(value) === index);
  };

  // Add last method to Array prototype if it doesn't exist
  if (!Array.prototype.last) {
    Array.prototype.last = function () {
      return this[this.length - 1];
    };
  }

// Select all elements with the id "font-specimen-block"
const newAppElements = document.querySelectorAll("*[featured-block]")
newAppElements.forEach((element) => {
  createApp(FeaturedBlock).mount(element);
});
}
